module.exports = __webpack_public_path__ + "img/AT0000002403465.53cd108b.png";